// extracted by mini-css-extract-plugin
module.exports = {"modifyModal":"EditValue_modifyModal__3AH5a","modifyBottomModal":"EditValue_modifyBottomModal__3EeVf","prestashopId":"EditValue_prestashopId__2FQnl"};